function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("g", null);

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "-250 -250 1000 1000"
}, props), /*#__PURE__*/React.createElement("rect", {
  x: 204.491,
  y: 49.964,
  style: {
    "fill": "#989487"
  },
  width: 103.018,
  height: 15.453
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#706B63"
  },
  d: "M374.213,39.662c-4.268,0-7.726,3.458-7.726,7.726v2.575h-28.072v15.453h28.072v2.575 c0,4.268,3.458,7.726,7.726,7.726c4.268,0,7.726-3.458,7.726-7.726V47.388C381.94,43.12,378.481,39.662,374.213,39.662z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#706B63"
  },
  d: "M302.616,39.662c4.268,0,7.726,3.458,7.726,7.726v2.575h28.072v15.453h-28.072v2.575 c0,4.268-3.458,7.726-7.726,7.726c-4.268,0-7.726-3.458-7.726-7.726V47.388C294.889,43.12,298.348,39.662,302.616,39.662z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#706B63"
  },
  d: "M338.414,79.839c-4.268,0-7.726-3.458-7.726-7.726V38.632c0-4.268,3.458-7.726,7.726-7.726 c4.268,0,7.726,3.458,7.726,7.726v33.481C346.141,76.381,342.683,79.839,338.414,79.839z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#706B63"
  },
  d: "M345.626,20.604h-7.211l-10.302,10.302l10.302,10.302h7.211c4.551,0,8.241-3.69,8.241-8.241v-4.121 C353.867,24.293,350.177,20.604,345.626,20.604z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#848075"
  },
  d: "M331.203,20.604c-4.551,0-8.241,3.689-8.241,8.241v4.121c0,4.551,3.69,8.241,8.241,8.241h7.211 V20.604H331.203z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#47423F"
  },
  d: "M348.716,0h-10.302l-10.302,10.302l10.302,20.604h20.604c5.69,0,10.302-4.612,10.302-10.302l0,0 C369.32,9.224,360.096,0,348.716,0z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#5B5751"
  },
  d: "M328.113,0c-11.379,0-20.604,9.224-20.604,20.604l0,0c0,5.69,4.612,10.302,10.302,10.302h20.604V0 H328.113z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#BB9430"
  },
  d: "M338.414,72.113l-10.302,10.302l10.302,30.905l20.604-17.995v-12.91 c0-5.69-4.612-10.302-10.302-10.302H338.414z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#F3E29A"
  },
  points: "338.414,72.113 328.113,72.113 321.932,85.505 328.113,104.342 338.414,113.32 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D9B43A"
  },
  d: "M317.811,82.414v12.949l10.302,8.978V72.113l0,0C322.423,72.113,317.811,76.725,317.811,82.414z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#BB9430"
  },
  d: "M359.018,95.325l-41.207,0.04C282.148,104.691,256,137.626,256,176.166v274.023 C256,484.326,283.674,512,317.811,512h41.207c34.137,0,61.811-27.674,61.811-61.811V175.131 C420.829,136.731,394.561,104.475,359.018,95.325z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D9B43A"
  },
  d: "M256.021,450.994c13.03,18.216,34.345,30.101,58.449,30.101h30.48 c11.219,0,21.02-7.842,23.195-18.848c0.014-0.072,0.029-0.144,0.042-0.216c0.744-3.832,1.133-7.791,1.133-11.841V175.131 c0-0.76-0.01-1.518-0.031-2.273c-1.965-72.518-110.413-72.474-113.225,0.014c-0.042,1.093-0.064,2.19-0.064,3.294v274.023 c0,1.328,0.057,2.641,0.139,3.948C256.074,453.096,256.034,452.049,256.021,450.994z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 256,
  y: 204.491,
  style: {
    "fill": "#ADA999"
  },
  width: 164.829,
  height: 226.64
}), /*#__PURE__*/React.createElement("rect", {
  x: 256,
  y: 204.491,
  style: {
    "fill": "#D5D2BD"
  },
  width: 113.32,
  height: 226.64
}), /*#__PURE__*/React.createElement("rect", {
  x: 286.905,
  y: 204.491,
  style: {
    "fill": "#E7E4CD"
  },
  width: 41.207,
  height: 226.64
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#47423F"
  },
  d: "M315.235,327.082c-15.621,0-28.33-12.709-28.33-28.33s12.709-28.33,28.33-28.33 c15.621,0,28.33,12.709,28.33,28.33S330.856,327.082,315.235,327.082z M315.235,285.875c-7.101,0-12.877,5.776-12.877,12.877 s5.776,12.877,12.877,12.877s12.877-5.776,12.877-12.877S322.336,285.875,315.235,285.875z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#47423F"
  },
  d: "M382.197,327.082h-25.755c-3.22,0-6.104-1.999-7.234-5.013c-1.131-3.016-0.273-6.416,2.154-8.534 l21.34-18.624c0.66-0.577,1.769-1.848,1.769-3.886c0-2.84-2.311-5.151-5.151-5.151c-2.84,0-5.151,2.311-5.151,5.151 c0,4.268-3.458,7.726-7.726,7.726c-4.268,0-7.726-3.458-7.726-7.726c0-11.361,9.243-20.604,20.604-20.604 c11.361,0,20.604,9.243,20.604,20.604c0,5.951-2.573,11.611-7.06,15.527l-5.818,5.077h5.151c4.268,0,7.726,3.458,7.726,7.726 C389.924,323.624,386.465,327.082,382.197,327.082z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#706B63"
  },
  d: "M209.384,39.662c-4.268,0-7.726,3.458-7.726,7.726v2.575h-28.072v15.453h28.072v2.575 c0,4.268,3.458,7.726,7.726,7.726c4.268,0,7.726-3.458,7.726-7.726V47.388C217.111,43.12,213.652,39.662,209.384,39.662z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#706B63"
  },
  d: "M173.586,79.839c-4.268,0-7.726-3.458-7.726-7.726V38.632c0-4.268,3.458-7.726,7.726-7.726 c4.268,0,7.726,3.458,7.726,7.726v33.481C181.312,76.381,177.854,79.839,173.586,79.839z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#706B63"
  },
  d: "M180.797,20.604h-7.211l-10.302,10.302l10.302,10.302h7.211c4.551,0,8.241-3.69,8.241-8.241v-4.121 C189.038,24.293,185.348,20.604,180.797,20.604z"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#848075"
  },
  d: "M166.374,20.604c-4.551,0-8.241,3.689-8.241,8.241v4.121c0,4.551,3.69,8.241,8.241,8.241h7.211 V20.604H166.374z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#47423F"
  },
  d: "M183.887,0h-10.302l-10.302,10.302l10.302,20.604h20.604c5.69,0,10.302-4.612,10.302-10.302l0,0 C204.491,9.224,195.267,0,183.887,0z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#5B5751"
  },
  d: "M163.284,0c-11.379,0-20.604,9.224-20.604,20.604l0,0c0,5.69,4.612,10.302,10.302,10.302h20.604V0 H163.284z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#BB9430"
  },
  d: "M173.586,72.113l-10.302,10.302l10.302,30.905l20.604-17.995v-12.91 c0-5.69-4.612-10.302-10.302-10.302H173.586z"
}), /*#__PURE__*/React.createElement("polygon", {
  style: {
    "fill": "#F3E29A"
  },
  points: "173.586,72.113 163.284,72.113 157.103,85.505 163.284,104.342 173.586,113.32 "
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D9B43A"
  },
  d: "M152.982,82.414v12.949l10.302,8.978V72.113l0,0C157.594,72.113,152.982,76.725,152.982,82.414z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#BB9430"
  },
  d: "M194.189,95.325l-41.207,0.04c-35.663,9.326-61.811,42.261-61.811,80.801v274.023 c0,34.137,27.674,61.811,61.811,61.811h41.207C228.326,512,256,484.326,256,450.189V175.131 C256,136.731,229.732,104.475,194.189,95.325z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#D9B43A"
  },
  d: "M91.192,450.994c13.03,18.216,34.345,30.101,58.449,30.101h30.48c11.219,0,21.02-7.842,23.195-18.848 c0.014-0.072,0.029-0.144,0.042-0.216c0.744-3.832,1.133-7.791,1.133-11.841V175.131c0-0.76-0.01-1.518-0.031-2.273 c-1.965-72.519-110.413-72.475-113.225,0.014c-0.042,1.093-0.064,2.19-0.064,3.294v274.023c0,1.328,0.057,2.641,0.139,3.948 C91.245,453.096,91.205,452.049,91.192,450.994z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 91.171,
  y: 204.491,
  style: {
    "fill": "#ADA999"
  },
  width: 164.829,
  height: 226.64
}), /*#__PURE__*/React.createElement("rect", {
  x: 91.171,
  y: 204.491,
  style: {
    "fill": "#D5D2BD"
  },
  width: 113.32,
  height: 226.64
}), /*#__PURE__*/React.createElement("rect", {
  x: 122.076,
  y: 204.491,
  style: {
    "fill": "#E7E4CD"
  },
  width: 41.207,
  height: 226.64
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#47423F"
  },
  d: "M150.406,327.082c-15.621,0-28.33-12.709-28.33-28.33s12.709-28.33,28.33-28.33 s28.33,12.709,28.33,28.33S166.027,327.082,150.406,327.082z M150.406,285.875c-7.101,0-12.877,5.776-12.877,12.877 s5.776,12.877,12.877,12.877s12.877-5.776,12.877-12.877S157.507,285.875,150.406,285.875z"
}), /*#__PURE__*/React.createElement("path", {
  style: {
    "fill": "#47423F"
  },
  d: "M217.368,327.082h-25.755c-3.22,0-6.104-1.999-7.235-5.013c-1.131-3.016-0.273-6.416,2.154-8.534 l21.34-18.624c0.66-0.577,1.769-1.848,1.769-3.886c0-2.84-2.311-5.151-5.151-5.151s-5.151,2.311-5.151,5.151 c0,4.268-3.458,7.726-7.726,7.726c-4.268,0-7.726-3.458-7.726-7.726c0-11.361,9.243-20.604,20.604-20.604 s20.604,9.243,20.604,20.604c0,5.951-2.573,11.611-7.061,15.527l-5.816,5.077h5.151c4.268,0,7.726,3.458,7.726,7.726 C225.095,323.624,221.636,327.082,217.368,327.082z"
})), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15);

export default __webpack_public_path__ + "static/media/O2.c518ddef.svg";
export { SvgComponent as ReactComponent };